<template>
  <div id="follow" v-if="datas.styleType == 2">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
      class="follow-box"
    >
      <!-- <template v-if="datas.styleType == 1">
        <div class="public_account_con">
          <div class="public_account_img">
            <img class="full_img" :src="defaultImg" alt="" />
          </div>
          <div class="public_account_info">
            <div>公众号名称</div>
            <div class="desc_con">公众号简介</div>
          </div>
        </div>
        <div class="public_account_btn">查看</div>
      </template> -->
      <template>
        <div
          class="follow-info"
          :style="{
            'font-size': datas.wordSize + 'px',
            'font-weight': datas.isBold ? 'bold' : 'normal',
            'font-style': datas.isTilt ? 'italic' : 'normal',
            'text-decoration': datas.isUnderLine ? 'underline' : 'none',
            color: datas.wordColor,
          }"
        >
          {{ datas.followDesc }}
        </div>
        <div class="follow-pic" @click="handleShowPublicDialog">
          <img :src="datas.btnImgUrl || defaultImg" alt="" />
        </div>
      </template>
    </div>

    <!-- 删除组件 -->
    <slot name="deles" />
    <van-overlay :show="showImgModal" z-index="5">
      <div class="overlay_con">
        <div class="img_info_con">
          <img
            v-if="datas['publicAccountUrl']"
            class="full_img"
            :src="datas['publicAccountUrl']"
            alt=""
          />
          <p v-else>请在后台配置公众号图片</p>
        </div>
        <van-icon
          name="close"
          class="close_btn_con"
          color="#fff"
          size="30"
          @click="showImgModal = false"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "Follow",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
      showImgModal: false,
    };
  },
  methods: {
    handleShowPublicDialog() {
      this.showImgModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
#follow {
  position: relative;
  width: 100%;
  .follow-box {
    display: flex;

    justify-content: space-between;
    align-items: center;
    .follow-pic {
      width: 120px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }
    .follow-info {
      flex: 1;
    }
    .public_account_con {
      display: flex;
      .public_account_img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
        overflow: hidden;
      }
      .public_account_info {
        .desc_con {
          color: #999;
          margin-top: 10px;
        }
      }
    }
    .public_account_btn {
      padding: 6px 15px;
      border-radius: 5px;
      border: 1px solid #07c160;
      color: #07c160;
    }
  }
  .overlay_con {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .img_info_con {
      background: #fff;
      width: 80%;
      height: 600px;
      text-align: center;
      border-radius: 20px;
      overflow: hidden;
      p {
        margin-top: 280px;
        color: #999;
      }
    }
  }
  .close_btn_con {
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
